interface CountBoxProps {
  count?: number;
  label?: string;
  className?: string;
}

export default function CountBox({ count = 0, label = "건수", className = "" }: CountBoxProps) {
  return (
    <div className={`flex mt-auto gap-1${className}`}>
      <span className="text-base font-normal text-[#333333]">{label}:</span>
      <span className="font-bold text-[#1E380B]">{count.toLocaleString()}</span>
    </div>
  );
}
